import { isString } from 'lodash-es';
import { NIMMessage } from '@yxim/nim-web-sdk/dist/SDK/NIM_Web_NIM/MessageInterface';
import { NIMSystemMessage } from '@yxim/nim-web-sdk/dist/SDK/NIM_Web_NIM/SystemMessageInterface';

const nimMsgContentParser = <R extends Object = Object>(
  p: NIMMessage | NIMSystemMessage,
): R | null => {
  try {
    if (p && isString(p.content)) {
      return JSON.parse(p.content);
    }
    return null;
  } catch (e) {
    console.log(e); // eslint-disable-line
    return null;
  }
};

export default nimMsgContentParser;
